<i18n lang="yaml">
en:
  empty: No keys found. Add a new key manually or import from GitHub or GitLab.
ru:
  empty: Ключи не найдены. Добавьте новый ключ вручную или импортируйте из GitHub или GitLab.
</i18n>
<script setup lang="ts">
import SSHKeyCard from '@/components/profileSettings/SSHKeyCard.vue'
import { useMyFetch } from '@/utils'
import { useAllStores } from '@/store'
import { ref } from 'vue'
import { handleError } from '@/utils/errors'

interface Key {
  fingerprint: string
  material: string
  type: string
  comment: string
}

const { alertStore, authStore, router, t } = useAllStores()
const keys = ref<Array<Key>>([])

async function fetchKeys() {
  const { data, error } = await useMyFetch('profile/keys').json()
  if (error.value) {
    await handleError(error, router, authStore, alertStore)
  } else {
    keys.value = data.value
  }
}

await fetchKeys()

async function deleteKey(material: String) {
  const { error } = await useMyFetch('profile/keys')
    .delete({
      material
    })
    .json()
  if (error.value) {
    await handleError(error, router, authStore, alertStore)
  } else {
    await fetchKeys()
  }
}
</script>

<template>
  <div class="card-body">
    <div v-if="keys && keys.length > 0">
      <div class="row p-2 mt-2" v-for="key in keys" :key="key.fingerprint">
        <SSHKeyCard
          v-on:delete="deleteKey"
          :comment="key.comment"
          :fingerprint="key.fingerprint"
          :key_type="key.type"
          :material="key.material"
        />
      </div>
    </div>
    <div v-else>
      <p>{{ t('empty') }}</p>
    </div>
  </div>
</template>
